import React, { useContext, useEffect, useState } from "react";
import { Heading, SectionHeading, SectionSamples, Textarea } from "../../../components";
import { ResumeContext } from "../../../contexts/resumeContext";

function HobbiesForm() {
  const {updateResumeInfo, resumeInfo} = useContext(ResumeContext);
  
  const [hobbies, setHobbies] = useState(resumeInfo?.misc?.hobbies || '')

  useEffect(() => {
    const miscSection = {...resumeInfo.misc}
    miscSection['hobbies'] = hobbies
    
    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [hobbies]);

  return (
    <>
      <SectionHeading editable content="Hobbies" section="HOB" subheading={<>What do you like? <SectionSamples section="HOB"/></>}/>
      <Textarea
        // label="What do you like?"
        rows={5}
        value={hobbies}
        onChange={(e) => setHobbies(e.target.value)}
        placeholder="e.g. Painting, Singing, Trekking"
      />
    </>
  );
}

export default HobbiesForm;
